import React from 'react';
import Layout from '../layouts/six';
import Title from '../partials/title';
import Who from './partials/who';
import EntryFee from './partials/entry_fee';
import How from './partials/how';
import CheckIn from './partials/check_in';
import Rules from './partials/rules';
import Elements from './partials/elements';
import NationalQualifying from './partials/national_qualifying';
import Communication from './partials/communication';
import ScrollAnimation from 'react-animate-on-scroll';

// August 6th: refactored for responsiveness
class GeneralInformation extends React.Component {

    render() {
        return <Layout nbs="information" title="GENERAL INFORMATION" bi="/images/backgrounds/girls-back.png">
            <section>
                <div className="w3-white">
                    <Who />
                </div>
                <div className="bg-blackish">
                    <ScrollAnimation animateIn="zoomIn" animateOnce={true} className="w3-container w3-content pt-8 pb-8">
                        <h3 className="white text-center">1st Division vs 2nd Division</h3>
                        <p className="white margin-top">Teams who's players have a higher skill level or want to be in the most competitive environment available, should register as 1st division. Teams that have lesser skilled or are new to the game, and don't want to play in the most competitive environment, should register as 2nd division. Based on a team's history, Challenge Sports reserves the right to place any team in the division it deems appropriate.</p>
                    </ScrollAnimation>
                </div>
                <div className="w3-white">
                    <EntryFee />
                </div>
                <div className="bg-whiteish">
                    <How />
                </div>
                <div className="w3-white">
                    <CheckIn />
                </div>
                <div className="w3-white">
                    <Rules />
                </div>
                <div className="bg-whiteish">
                    <Elements />
                </div>
                <div className="bg-blackish">
                    <div className="w3-container w3-content pt-8 pb-8">
                        <Title text="Sanctioning" className="white" />
                        <p className="white margin-top">These events are not FYSA or USYSA events and participants are not restricted by FYSA/USYSA rules and regulations. Participants are not covered by FYSA/USYSA supplemental insurance.</p>
                    </div>
                </div>
                <div className="w3-white">
                    <NationalQualifying />
                </div>
                <div className="w3-red">
                    <Communication />
                </div>
            </section>
        </Layout>
    }
}

export default GeneralInformation;



// WEBPACK FOOTER //
// ./src/components/information/index.js